/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {NgswCommChannel as Éµangular_packages_service_worker_service_worker_a} from './src/low_level';
export {RegistrationOptions as Éµangular_packages_service_worker_service_worker_b,SCRIPT as Éµangular_packages_service_worker_service_worker_c,ngswAppInitializer as Éµangular_packages_service_worker_service_worker_d,ngswCommChannelFactory as Éµangular_packages_service_worker_service_worker_e} from './src/module';